import { Module, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';

@Module({
  namespaced: true
})
class ScenarioConfigurationModule extends VuexModule {
  get getFields(): ScenarioExt {
    return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
  }

  get getGen(): boolean | null {
    return this.getFields.hasGenset;
  }
}

export default ScenarioConfigurationModule;
